import { ClipboardList } from 'lucide-react';

const PendingSalesEmpty = () => {
  return (
    <div
      className="
      flex
      flex-col
      items-center
      justify-center

      rounded-2xl

      border
      border-dashed
      border-stroke

      bg-whiten

      px-6
      py-14

      text-center

      dark:border-strokedark
      dark:bg-boxdark-2
    "
    >
      {/* Icon */}

      <div
        className="
        flex
        h-18
        w-18
        items-center
        justify-center

        rounded-2xl

        border
        border-primary/10

        bg-primary/5

        text-primary
      "
      >
        <ClipboardList size={32} />
      </div>

      {/* Title */}

      <h3
        className="
        mt-5

        text-base
        font-semibold

        text-black

        dark:text-white
      "
      >
        No hay ventas pendientes
      </h3>

      {/* Description */}

      <p
        className="
        mt-2
        max-w-[280px]

        text-sm
        leading-relaxed

        text-body
      "
      >
        Las ventas pausadas aparecerán aquí automáticamente para que puedas
        continuarlas cuando lo necesites.
      </p>
    </div>
  );
};

export default PendingSalesEmpty;
